export const environment = {
  production: true,
  // Relative URL: Frontend und API kommen vom selben Server — funktioniert
  // unter jeder Domain (kein CORS, kein Anpassen bei Domain-Wechsel).
  apiBaseUrl: '/api',
};
